import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
// import Header from '../components/Header'
// import Sidebar from '../components/Sidebar'

const DashFrame: React.FC = () => {
  return (
    <Box>
      <Outlet />
    </Box>
  );
};

export default DashFrame;
